enum SessionStatus {
    Ready = 'ready',
    Started = 'started',
    Completed = 'completed'
}

export default SessionStatus